<template>
  <div class="fire-detection-record">
    <MCard :title="$t('检测记录')" title-align="center">
      <search
        ref="search"
        class="custom-form-container"
        :formModel="formModel"
        :formButton="formButton"
        :deviceModelBusiType="12"
        :rules="rules"
        :mulTime="mulTime"
        :new-line="false"
        :filterDeviceFlag="true"
      ></search>

      <m-table
        max-height="550px"
        :loading="loading"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :pagiOption="pagiOption"
        v-on:search="search"
      ></m-table>
    </MCard>
  </div>
</template>

<script>
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';
import MCard from '@/components/mCard/index.vue';
import { gwDeviceCheckData } from '@/api/firefighting';

export default {
  components: {
    Search,
    MTable,
    MCard
  },
  data() {
    const { translateTo } = this.$options.filters;

    const i18nPath = 'query';

    const timeValidate = (_, value, callback) => {
      if (!value[0] || !value[1]) {
        callback(new Error(translateTo('请选择日期', i18nPath)));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      i18nPath,
      formModel: {
        // deviceModel: [],
        sn: '',
        rangeDateVal: [new Date() - 3600000, new Date().getTime()]
      },
      formButton: [
        {
          text: '查询',
          loading: false,
          event: op => {
            this.pagiOption.offset = 1;
            this.search(op);
          }
        }
      ],
      tableData: [],
      tableColumn: [],
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      rules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'change' }],
        rangeDateVal: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { validator: timeValidate }
        ]
      },
      mulTime: {
        mul: false,
        dateType: 'datetimerange'
      }
    };
  },
  computed: {
    comParams() {
      return {
        beginTime: this.formModel.rangeDateVal[0],
        endTime: this.formModel.rangeDateVal[1],
        sn: this.formModel.sn
      };
    }
  },

  methods: {
    langChangeHandler() {
      this.$refs.search.validateEvent({
        event: () => {
          this.search();
        }
      });
    },
    search(op) {
      this.loading = true;
      op && (op.loading = true);
      gwDeviceCheckData(
        Object.assign(
          {
            limit: this.pagiOption.limit,
            offset: this.pagiOption.offset
          },
          this.comParams
        )
      )
        .then(res => {
          let resultDict = {
            0: '阴性',
            1: '阳性',
            2: '无效'
          };
          this.tableData = res.data.pageData.list;
          this.tableData.forEach(item => {
            if (item.testId) {
              item.testId = item.testId.split('\u0000')[0];
            }
            item.detectType = item.name;
            item.detectResult = resultDict[item.detectResult];
          });
          this.tableColumn = (res.data?.dimensions || []).map((e, i) => ({
            prop: e,
            label: res.data.dimensionsZh[i]
          }));

          this.pagiOption.total = res.data.pageData.total;
        })
        .finally(() => {
          this.loading = false;
          op && (op.loading = false);
        });
    }
  }
};
</script>

<style lang="scss">
.fire-detection-record {
  width: calc(100% - 155px);
  height: calc(100% - 30px);
  margin-left: var(--gap);

  box-sizing: border-box;

  .m-card_content {
    padding: 20px;
    box-sizing: border-box;

    overflow: auto;

    @include scrollar-style-thin;
  }
}
</style>
